import axios from 'axios';

const state = {
    user: null,
    token: null
};

const getters = {
    isAuthenticated: state => !!state.token,    
    StateUser: state => state.user,
    StateToken: state => state.token
};

const actions = {
    async LogIn({commit}, user) {
        const res = await axios.post('login', user);
        if (res.status == 200 ) {
            await commit('setUser', { orga: res.data.orga, orgaName: res.data.orgaName, orgaValid: res.data.orgaValid, id: res.data.id, username: res.data.username, email: user.email, role: res.data.role, phone: res.data.phone, haveSMSNotif: res.data.haveSMSNotif, password: user.password });
            await commit('setToken', res.data.token);
        }
    },
    async ReLog({commit}, user) {
        const res = await axios.post('relog', user);
        if (res.status == 200 ) {
            await commit('setUser', { orga: res.data.orga, orgaName: res.data.orgaName, orgaValid: res.data.orgaValid, id: res.data.id, username: res.data.username, email: user.email, role: res.data.role, phone: res.data.phone, haveSMSNotif: res.data.haveSMSNotif, password: user.password });
            await commit('setToken', res.data.token);
        }
    },
    async LogOut({commit}){
        await commit('logout');
    },
    async SetUser({commit, state}, user) {
        await commit('setUser', { orga: user.orga, orgaName: user.orgaName, orgaValid: user.orgaValid, id: state.user.id, username: user.username, email: user.email, role: user.role, phone: user.phone, haveSMSNotif: user.haveSMSNotif, password: state.user.password });
        await commit('setToken', user.token);
    },
    async ChangeGrp({commit, state}, user) {
        await commit('setUser', { orga: user.orga, orgaName: user.orgaName, orgaValid: user.orgaValid, id: state.user.id, username: state.user.username, email: state.user.email, role: user.role, phone: state.user.phone, haveSMSNotif: state.user.haveSMSNotif, password: state.user.password });
        const res = await axios.post('token', user);
        if (res.status == 200) {
            await commit('setToken', res.data.token);
        }
    },
    async ChangeCurrentOrgaName({commit}, orga) {
        await commit('setOrga', orga);
    },
};

const mutations = {
    setUser(state, user){
        state.user = user;
    },
    setToken(state, token){
        state.token = token;
    },
    logout(state){
        state.user = null;
        state.token = null;
    },
    setOrga(state, orga){
        state.user.orgaName = orga;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};